import { STATUS } from "@/constant/statusConstants";
import * as Yup from "yup";
import { DEFAULT_LANGUAGE } from "@/constant/Languages/language";
import {
  BOOLEAN_OPTIONS,
  booleanOptionLabels,
} from "@/constant/GeneralOptions/boolean";

const booleanOptionLabelsMap = booleanOptionLabels();
const boLabelYes = booleanOptionLabelsMap[BOOLEAN_OPTIONS.YES];
const boLabelNo = booleanOptionLabelsMap[BOOLEAN_OPTIONS.NO];

const TeamSchema = (
  localeCodes,
  isEdit = false,
  targetLang = DEFAULT_LANGUAGE
) =>
  Yup.object().shape({
    sport_id: Yup.string()
      .label("Sport")
      .when([], {
        is: () => targetLang === DEFAULT_LANGUAGE,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.nullable(),
      }),
    code: Yup.string()
      .label("ID")
      .max(50)
      .when([], {
        is: () => targetLang === DEFAULT_LANGUAGE,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.nullable(),
      }),
    name: Yup.string()
      .label(`Name (${targetLang.toUpperCase()})`)
      .when([], {
        is: () => !isEdit && targetLang === DEFAULT_LANGUAGE,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.nullable(),
      }),
    icon_url: Yup.mixed()
      .label("Icon")
      .when([], {
        is: () => !isEdit && targetLang === DEFAULT_LANGUAGE,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.nullable(),
      }),
    thumbnail_url: Yup.mixed()
      .label("Thumbnail Image")
      .when([], {
        is: () => !isEdit && targetLang === DEFAULT_LANGUAGE,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.nullable(),
      }),
    banner_url: Yup.mixed()
      .label("Banner Image")
      .when([], {
        is: () => !isEdit && targetLang === DEFAULT_LANGUAGE,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.nullable(),
      }),
    hexcode_1: Yup.string().label("Hexcode 1").nullable().max(50),
    hexcode_2: Yup.string().label("Hexcode 2").nullable().max(50),
    hexcode_3: Yup.string().label("Hexcode 3").nullable().max(50),
    city: Yup.string().label("City").nullable(),
    country_id: Yup.number().label("Country").nullable(),
    show_in_profile: Yup.boolean()
      .label("Show Profile")
      .when([], {
        is: () => targetLang === DEFAULT_LANGUAGE,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.nullable(),
      })
      .oneOf(
        Object.values(BOOLEAN_OPTIONS),
        `Show Profile must be one of the following values: ${Object.values(
          booleanOptionLabels
        ).join(", ")}`
      ),
    is_national_team: Yup.boolean()
      .label("National Team")
      .when([], {
        is: () => targetLang === DEFAULT_LANGUAGE,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.nullable(),
      })
      .oneOf(
        Object.values(BOOLEAN_OPTIONS),
        `National Team must be one of the following values: ${Object.values(
          booleanOptionLabels
        ).join(", ")}`
      ),
    is_icon_bordered: Yup.boolean()
      .label("Icon Bordered")
      .when([], {
        is: () => targetLang === DEFAULT_LANGUAGE,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.nullable(),
      })
      .oneOf(
        Object.values(BOOLEAN_OPTIONS),
        `Icon Bordered must be one of the following values: ${Object.values(
          booleanOptionLabels
        ).join(", ")}`
      ),
    foundation_year: Yup.string().label("Foundation Year").nullable(),
    stadium_name: Yup.string().label("Stadium Name").nullable(),
    stadium_capacity: Yup.string().label("Stadium Capacity").nullable(),
    field_length: Yup.number().label("Field Length").nullable(),
    field_width: Yup.number().label("Field Width").nullable(),
    anthem_name: Yup.string().label("Anthem Name").nullable(),
    mascot_1: Yup.string().label("Maskot 1").nullable(),
    mascot_2: Yup.string().label("Maskot 2").nullable(),
    rival_team_id_1: Yup.number().label("Rival Team 1").nullable(),
    rival_team_id_2: Yup.number().label("Rival Team 2").nullable(),
    rival_team_id_3: Yup.number().label("Rival Team 3").nullable(),
    tags: Yup.array().label("Player Name (Tags)").nullable(),
    tagline: Yup.string().label("Sub Title").required().max(120),
    content: Yup.string().label("Content").required(),
    auto_translate: Yup.bool()
      .label("Translate All")
      .nullable()
      .oneOf(
        Object.values(BOOLEAN_OPTIONS),
        `Translate All must be one of the following values: ${boLabelYes}, ${boLabelNo}`
      ),
    status: Yup.string()
      .label("Status")
      .when([], {
        is: () => targetLang === DEFAULT_LANGUAGE,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.nullable(),
      })
      .oneOf(Object.values(STATUS)),
  });

export default TeamSchema;
